<script setup>
import {computed, onUnmounted, getCurrentInstance, set, del} from 'vue'

const props = defineProps({
    allowAll: Boolean
})

const {proxy} = getCurrentInstance()
const store = proxy.$store
const route = proxy.$route

// --- Computed ---
const formData = computed(() => store.state.odpReports.formData)
const franchises = computed(() => store.state.odpReports.franchises)
const unsetValue = computed(() => props.allowAll ? 0 : '')
const userFranchiseId = computed(() => store.state.user.user.franchiseId)
const show = computed(() => userFranchiseId.value === 0)

// --- "Created" Logic ---
// Logic in script setup runs during the component creation phase
const initialFranchiseId = route.query.franchiseId
    ? parseInt(route.query.franchiseId)
    : unsetValue.value

// Use 'set' from vue for Vue 2 reactivity when adding a new property
set(formData.value, 'franchiseId', initialFranchiseId)

// --- "Destroyed" Logic ---
onUnmounted(() => {
    // Use 'del' from vue to maintain reactivity in Vue 2
    del(formData.value, 'franchiseId')
})
</script>

<template>
    <select v-if="show" v-model="formData.franchiseId" class="form-select form-select-sm"
            name="franchiseId" required>
        <option v-if="allowAll" :value="0">- All -</option>
        <option v-else value="" selected disabled>Select&hellip;</option>
        <template v-if="franchises">
            <option v-for="franchise in franchises" :key="franchise.id" :value="franchise.id">
                {{ franchise.title }}
            </option>
        </template>
    </select>
</template>